import { convertHex } from 'utils/style/color';
import styled, { css } from 'styled-components';

interface WrapperKeyProps {
  copied: boolean;
}

const CopyToClipBoardContainer = styled.div`
  padding: 5px 0px;
`;

const WrapperKey = styled.div<WrapperKeyProps>`
  ${({ theme: { typography } }) => typography.nomalText()};
  align-items: center;
  background: ${({ theme: { color } }) => color.white_600};
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 7px 12px;
  transition: background 0.5s ease-in-out;
  gap: 10px;
  max-width: 285px;

  &:hover {
    background: ${({ theme: { color } }) => convertHex(color.PLColor2, 0.1)};
  }

  ${({ copied, theme: { color } }) =>
    copied &&
    css`
      background: ${convertHex(color.PLColor2, 0.1)};
    `}

  > button {
    ${({ theme: { typography } }) => typography.smallText()};
    align-items: center;
    background: transparent;
    border: 0;
    color: ${({ theme: { color } }) => color.PLColor1};
    cursor: pointer;
    display: flex;
    font-weight: bold;
    svg {
      padding-right: 8px;
    }
  }

  ${({ theme: { mui } }) => css`
    ${mui.breakpoints.down('sm')} {
      padding: 19px 15px;
      > button > span {
        display: none;
      }
    }
  `}
`;

const TextKey = styled.div`
  max-width: 390px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export { TextKey, CopyToClipBoardContainer, WrapperKey };
